function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// Shared by the live Explorer and the offline archive importer. This is an
// observation index, not consensus state. NULL chain status means unknown.
var SCHEMA = ["CREATE TABLE IF NOT EXISTS explorer_chain_blocks (\n    hash TEXT PRIMARY KEY, height INTEGER NOT NULL, parent_hash TEXT NOT NULL,\n    timestamp INTEGER NOT NULL, creator TEXT NOT NULL,\n    tx_count INTEGER, size_bytes INTEGER, in_longest_chain INTEGER,\n    file_path TEXT, body_available INTEGER NOT NULL DEFAULT 0\n  )", "CREATE INDEX IF NOT EXISTS explorer_chain_height ON explorer_chain_blocks(height, hash)", "CREATE INDEX IF NOT EXISTS explorer_chain_parent ON explorer_chain_blocks(parent_hash)", "CREATE TABLE IF NOT EXISTS explorer_chain_files (\n    path TEXT PRIMARY KEY, size INTEGER NOT NULL, mtime REAL NOT NULL\n  )"];
var ChainDatabase = /*#__PURE__*/function () {
  function ChainDatabase(db) {
    _classCallCheck(this, ChainDatabase);
    this.db = db;
  }
  return _createClass(ChainDatabase, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _i, _SCHEMA, sql;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _i = 0, _SCHEMA = SCHEMA;
            case 1:
              if (!(_i < _SCHEMA.length)) {
                _context.n = 3;
                break;
              }
              sql = _SCHEMA[_i];
              _context.n = 2;
              return this.db.run(sql);
            case 2:
              _i++;
              _context.n = 1;
              break;
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(block) {
        var _block$tx_count, _block$size_bytes, _block$in_longest_cha, _block$file_path;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.db.run("INSERT INTO explorer_chain_blocks\n      (hash, height, parent_hash, timestamp, creator, tx_count, size_bytes,\n       in_longest_chain, file_path, body_available)\n      VALUES ($hash, $height, $parent_hash, $timestamp, $creator, $tx_count,\n        $size_bytes, $in_longest_chain, $file_path, $body_available)\n      ON CONFLICT(hash) DO UPDATE SET\n        tx_count = COALESCE(excluded.tx_count, tx_count),\n        size_bytes = COALESCE(excluded.size_bytes, size_bytes),\n        in_longest_chain = COALESCE(excluded.in_longest_chain, in_longest_chain),\n        file_path = COALESCE(excluded.file_path, file_path),\n        body_available = CASE WHEN excluded.file_path IS NULL THEN body_available\n          ELSE excluded.body_available END", {
                $hash: block.hash,
                $height: block.height,
                $parent_hash: block.parent_hash,
                $timestamp: block.timestamp,
                $creator: block.creator,
                $tx_count: (_block$tx_count = block.tx_count) !== null && _block$tx_count !== void 0 ? _block$tx_count : null,
                $size_bytes: (_block$size_bytes = block.size_bytes) !== null && _block$size_bytes !== void 0 ? _block$size_bytes : null,
                $in_longest_chain: (_block$in_longest_cha = block.in_longest_chain) !== null && _block$in_longest_cha !== void 0 ? _block$in_longest_cha : null,
                $file_path: (_block$file_path = block.file_path) !== null && _block$file_path !== void 0 ? _block$file_path : null,
                $body_available: block.body_available ? 1 : 0
              });
            case 1:
              if (!(block.in_longest_chain === 1)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return this.status(block.hash, true);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function put(_x) {
        return _put.apply(this, arguments);
      }
      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(hash) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2, this.db.get('SELECT * FROM explorer_chain_blocks WHERE hash = ?', hash));
          }
        }, _callee3, this);
      }));
      function get(_x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "getAtHeight",
    value: function () {
      var _getAtHeight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(height) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              return _context4.a(2, this.db.get("SELECT * FROM explorer_chain_blocks WHERE height = ?\n       ORDER BY in_longest_chain DESC, hash LIMIT 1", height));
          }
        }, _callee4, this);
      }));
      function getAtHeight(_x3) {
        return _getAtHeight.apply(this, arguments);
      }
      return getAtHeight;
    }()
  }, {
    key: "range",
    value: function () {
      var _range = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(from, to) {
        var afterHeight,
          afterHash,
          limit,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              afterHeight = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : 0;
              afterHash = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : '';
              limit = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : 501;
              return _context5.a(2, this.db.all("SELECT * FROM explorer_chain_blocks\n      WHERE height BETWEEN ? AND ? AND (height > ? OR (height = ? AND hash > ?))\n      ORDER BY height, hash LIMIT ?", from, to, afterHeight, afterHeight, afterHash, limit));
          }
        }, _callee5, this);
      }));
      function range(_x4, _x5) {
        return _range.apply(this, arguments);
      }
      return range;
    }()
  }, {
    key: "bounds",
    value: function () {
      var _bounds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2, this.db.get('SELECT MIN(height) AS oldest, MAX(height) AS newest FROM explorer_chain_blocks'));
          }
        }, _callee6, this);
      }));
      function bounds() {
        return _bounds.apply(this, arguments);
      }
      return bounds;
    }()
  }, {
    key: "status",
    value: function () {
      var _status = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(hash, lc) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!lc) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return this.db.run("UPDATE explorer_chain_blocks SET in_longest_chain = CASE WHEN hash = ? THEN 1 ELSE 0 END\n         WHERE height = (SELECT height FROM explorer_chain_blocks WHERE hash = ?)", hash, hash);
            case 1:
              return _context7.a(2);
            case 2:
              _context7.n = 3;
              return this.db.run('UPDATE explorer_chain_blocks SET in_longest_chain = ? WHERE hash = ?', lc ? 1 : 0, hash);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function status(_x6, _x7) {
        return _status.apply(this, arguments);
      }
      return status;
    }()
  }, {
    key: "reconcileAncestors",
    value: function () {
      var _reconcileAncestors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(from, to) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.db.run("WITH RECURSIVE ancestors(hash, parent_hash, height) AS (\n      SELECT hash, parent_hash, height FROM explorer_chain_blocks\n        WHERE in_longest_chain = 1 AND height BETWEEN ? AND ?\n      UNION\n      SELECT b.hash, b.parent_hash, b.height FROM explorer_chain_blocks b\n        JOIN ancestors a ON b.hash = a.parent_hash AND b.height = a.height - 1\n        WHERE b.height >= ?\n    ) UPDATE explorer_chain_blocks SET in_longest_chain = 1\n      WHERE hash IN (SELECT hash FROM ancestors)", from, to + 1, from);
            case 1:
              _context8.n = 2;
              return this.db.run("UPDATE explorer_chain_blocks SET in_longest_chain = 0\n      WHERE height BETWEEN ? AND ? AND in_longest_chain IS NULL\n      AND height IN (SELECT height FROM explorer_chain_blocks WHERE in_longest_chain = 1\n        AND height BETWEEN ? AND ?)", from, to, from, to);
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function reconcileAncestors(_x8, _x9) {
        return _reconcileAncestors.apply(this, arguments);
      }
      return reconcileAncestors;
    }()
  }, {
    key: "fileSeen",
    value: function () {
      var _fileSeen = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(path, stat) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              return _context9.a(2, this.db.get('SELECT path FROM explorer_chain_files WHERE path = ? AND size = ? AND mtime = ?', path, stat.size, stat.mtimeMs));
          }
        }, _callee9, this);
      }));
      function fileSeen(_x0, _x1) {
        return _fileSeen.apply(this, arguments);
      }
      return fileSeen;
    }()
  }, {
    key: "rememberFile",
    value: function () {
      var _rememberFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(path, stat) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.db.run('INSERT OR REPLACE INTO explorer_chain_files(path, size, mtime) VALUES (?, ?, ?)', path, stat.size, stat.mtimeMs);
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function rememberFile(_x10, _x11) {
        return _rememberFile.apply(this, arguments);
      }
      return rememberFile;
    }()
  }]);
}();
module.exports = {
  ChainDatabase: ChainDatabase,
  SCHEMA: SCHEMA
};